import CodingBlogs from '@components/coding-for-kids/coding-blogs'
import CodingForKidsFold from '@components/coding-for-kids/coding-for-kids'
import CodingGuides from '@components/coding-for-kids/coding-guides'
import CodingMasterClasses from '@components/coding-for-kids/coding-masterclasses'
import CodingQuizzesForKids from '@components/coding-for-kids/coding-quizzes-kids'
import CodingWebinars from '@components/coding-for-kids/coding-webinars'
import CodingWorkSheets from '@components/coding-for-kids/coding-worksheets'
import FirstFold from '@components/coding-for-kids/first-fold'
import Footer from '@components/common/footer'
import NavBar from '@components/common/navbar'
import CompetitionsFold from '@components/home/competitions-fold'
import Faq from '@components/home/faq'
import Courses from '@components/locale-pages/home/courses'
import useStoreUTMParams from '@hooks/useStoreUTMParam'
import { CODING_FOR_KIDS_FAQ } from '@lib/data/faq'
import { codingForKidsGlobalSeo } from '@lib/lp-seo'
import { FAQPageJsonLd, NextSeo } from 'next-seo'
import CodingalProductBlog from '@components/blog/product-blogs'
import TableOfContents from '@components/coding-for-kids/table-of-contents'
import { VIDEO_TESTIMONIAL } from '@lib/data/summer-coding-camp'
import TrustpilotReview from '@components/locale-pages/home/trustpilot-review'
import VideoTestimonial from '@components/locale-pages/home/video-testimonial'
import { Trans } from '@lingui/macro'
import Button from '@components/atoms/button'

const GRADE_LINKS = [
  { label: 'Grades 1–3 (Ages 6–9)', href: '/coding-for-kids/grade-1-3/' },
  { label: 'Grades 4–5 (Ages 9–11)', href: '/coding-for-kids/grade-4-5/' },
  { label: 'Grades 6–8 (Ages 11–14)', href: '/coding-for-kids/grade-6-8/' },
  { label: 'Grades 9–10 (Ages 14–16)', href: '/coding-for-kids/grade-9-10/' },
  { label: 'Grades 11–12 (Ages 16–18)', href: '/coding-for-kids/grade-11-12/' },
]

const CodingClassesByGrade = () => (
  <div
    id="courses-by-grade"
    className="px-5 container mx-auto my-12 lg:my-16 text-center"
  >
    <h2 className="text-2xl lg:text-4xl font-600 mb-4">
      Coding classes by grade
    </h2>
    <div className="flex flex-wrap gap-4 justify-between">
      {GRADE_LINKS.map(({ label, href }) => (
        <a key={href} href={href}>
          <Button variant="link">{label}</Button>
        </a>
      ))}
    </div>
  </div>
)

const CodingForKids = () => {
  useStoreUTMParams()

  return (
    <>
      <NextSeo {...codingForKidsGlobalSeo} />
      <FAQPageJsonLd
        mainEntity={CODING_FOR_KIDS_FAQ.map(
          ({ acceptedAnswerTextString, questionName }) => ({
            acceptedAnswerText: acceptedAnswerTextString,
            questionName: questionName,
          })
        )}
      />
      {/* <CarouselJsonLd ofType="course" data={COURSE_CAROUSEL_SCHEMA_DATA} /> */}
      <NavBar />
      <FirstFold />
      <TableOfContents />

      <CodingForKidsFold />
      <CompetitionsFold
        heading="Coding competitions for kids"
        subHeading="These competitions are an excellent way for kids to start learning to code in a fun context.  Our expert computer science teachers help kids build their first coding project with 1:1 free mentorship sessions."
        shouldShowCTAs={true}
        ctaSize="md"
        shouldShowPracticeCompetitions
      />
      <CodingQuizzesForKids />
      <CodingMasterClasses />
      <CodingWorkSheets />
      <CodingBlogs />
      <CodingGuides />
      <CodingWebinars />
      <Courses />
      <CodingClassesByGrade />
      <div className="pb-4">
        <VideoTestimonial
          title={
            <Trans>
              Students and parents love Codingal’s training program and
              curriculum
            </Trans>
          }
          video_testimonial={VIDEO_TESTIMONIAL}
        />
        <TrustpilotReview ctaSize="md" />
      </div>
      <CodingalProductBlog isCodingForKids />
      <div className="mb-20">
        <Faq faqContents={CODING_FOR_KIDS_FAQ} />
      </div>
      <Footer />
    </>
  )
}

// TODO: Remove once getInitialProps is removed from _app.tsx
export const getStaticProps = async () => {
  return {
    props: {},
  }
}

export default CodingForKids
